module.exports = __webpack_public_path__ + "static/media/sub_icon_black.abe681bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sub_icon_black.svg
// module id = 1119
// module chunks = 0